/**
 * Auto-generated from dark-roast DAOs (com.axiom.db.models.dao).
 * Shared by all Java backends — do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Entity } from '@data-client/rest';
import { BusinessTitle } from '../enums/business-title';
import { PositionReservedType } from '../enums/position-reserved-type';
import { PositionRole } from '../enums/position-role';
import { PositionWorksite } from '../enums/position-worksite';
import { WeeklyTimeUnit } from '../enums/weekly-time-unit';
import { CandidateOpportunityEntity } from './candidate-opportunity-entity';
export class PositionEntity extends Entity {
  aiDescription: string | null = null;
  baselineBillRate: number | null = null;
  baselineCost: number | null = null;
  baselineMargin: number | null = null;
  billingHoursPerDay: number | null = null;
  billingUnitsPerWeek: number | null = null;
  businessTitle: BusinessTitle | null = null;
  candidateOpportunities: CandidateOpportunityEntity[] = [];
  createdAt: string | null = null;
  demandDriver: string | null = null;
  description: string | null = null;
  endDate: string | null = null;
  endDateStatus: string | null = null;
  id: string = '';
  integrationId: string | null = null;
  isPremium: boolean | null = null;
  name: string | null = null;
  opportunityId: string | null = null;
  product: string | null = null;
  reservedType: PositionReservedType | null = null;
  role: PositionRole | null = null;
  salesforceId: string | null = null;
  startDate: string | null = null;
  talentExperienceYears: string | null = null;
  updatedAt: string | null = null;
  weeklyTimeUnit: WeeklyTimeUnit | null = null;
  worksite: PositionWorksite | null = null;
  estimatedEngagementTotalMonths?: number | null = null;
  static override key = 'Position';
  static override get schema() {
    return {
      candidateOpportunities: [CandidateOpportunityEntity],
    };
  }
  static override toJSON() {
    return { name: this.name, schema: {}, key: this.key };
  }
  static override process(input: unknown): unknown {
    if (
      input !== null &&
      typeof input === 'object' &&
      'Position' in input
    ) {
      const { Position: wrapped, ...rest } = input as {
        Position: object;
      } & object;
      return { ...(wrapped as object), ...rest };
    }
    return input;
  }
}